// removed by extract-text-webpack-plugin
module.exports = {"icon-container":"QuestionBankTable__icon-container___1uXIW"};